import * as CONST from "./actionTypes";

const intialState = {
  isLogin: false,
  loading: false,
  token: (localStorage && localStorage.getItem("token")) || null,
  _id: (localStorage && localStorage.getItem("_id")) || null,
  profileImage: (localStorage && localStorage.getItem("profileImage")) || null,
};

const authReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    case CONST.LOGIN:
      return {
        ...state,
        loading: true,
      };

    case CONST.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        token: payload.token,
        profileImage: payload.profileImage,
        _id: payload._id,
      };

    case CONST.LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        token: null,
        profileImage: null,
        _id: null,
      };

    case CONST.LOG_OUT:
      localStorage.clear() 
      payload()
      return {
        ...state,
        loading: false,
        token: null,
        profileImage: null,
        _id: null,
      };

    default:
      return state;

      break;
  }
};

export default authReducer;
